import * as R from 'ramda';
import moment from 'moment';

export default function EditAgendaItemDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  addAgendaItemNoteDialog,
  attachAgendaItemDialog,
  docDataService,
  serviceIds,
  loaderService,
  oversightDataService,
  ssDialogService
) {
  const vm = this;
  vm.serviceId = serviceIds.oversight;
  vm.appLoaded = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditAgendaItemFormSubmit = _handleEditAgendaItemFormSubmit;
  vm.handleAssignmentChange = handleAssignmentChange;
  vm.handleAddAgendaNotesDialog = _handleAddAgendaNotesDialog;
  vm.handleAttachItems = _handleAttachItems;
  vm.documentAttached = _documentAttached;

  if (vm.item.completedDate) {
    vm.lastCompletedDate = vm.item.completedDate;
  }
  if (vm.item.dueDate) {
    vm.dueDate = moment(vm.item.dueDate);
  }

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.appLoaded = true;
    $scope.$on('refreshAgendaItemComments', (event, opt) => {
      if (opt.agendaItemId === vm.item.agendaItemId) {
        _refreshAgendaItemComments();
      }
    });

    $scope.$on('refreshAgendaItemDocuments', (event, opt) => {
      if (opt.agendaItemId === vm.item.agendaItemId) {
        _refreshAgendaItemDocuments();
      }
    });

    $scope.$on('refreshAgendaItemReports', (event, opt) => {
      if (opt.agendaItemId === vm.item.agendaItemId) {
        _refreshAgendaItemReports();
      }
    });

    $scope.$on('refreshAgendaItemFolders', (event, opt) => {
      if (opt.agendaItemId === vm.item.agendaItemId) {
        _refreshAgendaItemFolders();
      }
    });

    $scope.$on('refreshAgendaItemEdit', (event, opt) => {
      if (opt.agendaItemId === vm.item.agendaItemId) {
        _refreshAgendaItem();
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
      }
    });
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.editAgendaItemDialog);
  }

  function _handleEditAgendaItemFormSubmit() {
    const dfdRefresh = $q.defer();

    if ($scope.editAgendaItemForm.$invalid) {
      return dfdRefresh.resolve();
    }

    if (!_isValid()) {
      // Set the form as unsubmitted since the user needs to make changes
      $scope.editAgendaItemForm.$setPristine();
      $scope.editAgendaItemForm.$setUntouched();
      return dfdRefresh.resolve();
    }

    if (!R.isNil(vm.dueDate)) {
      vm.item.dueDate = moment(vm.dueDate).format('MM/DD/YYYY');
    }

    loaderService.showViewLoader = true;
    oversightDataService.updateAgendaItem(vm.item).then((response) => {
      const savedAgendaItem = response.data;
      if (savedAgendaItem.agendaItemId === 'undefined' || savedAgendaItem.agendaItemId <= 0) {
        // There was an error saving the agenda information
        alerts.error('An error occurred while updating agenda item.');
        dfdRefresh.reject();
        loaderService.showViewLoader = false;
      } else {
        // The agenda information has been saved
        vm.item = savedAgendaItem;
        alerts.success('The Agenda Item has been successfully completed.');
        loaderService.showViewLoader = false;
        ssDialogService.hide(ssDialogService.dialogs.oversight.editAgendaItemDialog)
          .then(dfdRefresh.resolve);
        if (vm.refreshAgendaItem === true) {
          $rootScope.$broadcast('refreshUpdateAgendaItem', { agendaItemId: vm.item.agendaItemId });
        } else {
          $rootScope.$broadcast('refreshUpdateAgendaSubItem', { agendaItemId: vm.item.agendaItemId });
        }
      }
    });

    return dfdRefresh.promise;
  }

  function _handleAddAgendaNotesDialog($event) {
    ssDialogService.dialogs.oversight.addAgendaItemNoteDialog = ssDialogService.alert(
      addAgendaItemNoteDialog.getOptions($event, {
        agendaItemId: vm.item.agendaItemId,
        agendaItemCommentId: -1,
        agendaItemCommentText: '',
        agendaItemFollowupId: -1,
        agendaItemFollowupText: '',
        refreshAgendaItem: false
      })
    );
    ssDialogService.show(ssDialogService.dialogs.oversight.addAgendaItemNoteDialog);
  }

  function _handleAttachItems($event) {
    loaderService.showViewLoader = true;
    docDataService.getFolderProperties(-1).then((getFolderResponse) => {
      vm.rootFolder = getFolderResponse.data;

      ssDialogService.dialogs.oversight.attachAgendaItemDocumentDialog = ssDialogService.alert(
        attachAgendaItemDialog.getOptions($event, {
          serviceId: vm.serviceId,
          agendaItemId: vm.item.agendaItemId,
          folder: vm.rootFolder,
          attachCallback: vm.documentAttached,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.oversight.attachAgendaItemDocumentDialog);
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.item.agendaItemId });
  }


  /**
   * Sync statusId and assignedToUser to assignedToUserId
   */
  function handleAssignmentChange() {
    vm.item.assignedToUserId = vm.item.assignedToUser.userId;
    if (vm.item.agendaItemStatusId !== 3) { // Completed
      if (vm.item.assignedToUserId > 0) {
        vm.item.agendaItemStatusId = 2; // Assigned
      } else {
        vm.item.agendaItemStatusId = 1; // Unassigned
      }
    }
  }

  function _isValid() {
    let isValid = true;
    /* isValid = _areDatesValid();
    angular.forEach($scope.editAMFindingForm.$error.pattern, () => {
      isValid = false;
    });
    angular.forEach($scope.editAMFindingForm.$error.required, () => {
      isValid = false;
    });
    if (!isValid) {
      alerts.error('There were errors saving the Finding.');
    } */
    // Add conditional errors
    if (isValid) {
      if (!_hasBothAssignedUserAndDueDateOrNeither()) {
        alerts.error('If the Due Date or Assigned User is entered, then both must be set in the Agenda Item.');
        isValid = false;
      }
    }
    return isValid;
  }

  function _hasBothAssignedUserAndDueDateOrNeither() {
    // Is assigned to user
    const a = vm.item.assignedToUserId && vm.item.assignedToUserId > -1;
    // Has a due date
    const b = !!vm.dueDate;

    if (a || b) return a && b; // has both?
    return true; // has neither
  }

  function _refreshAgendaItemComments() {
    const dfdRefresh = $q.defer();

    oversightDataService.getCommentsByAgendItem(vm.item.agendaItemId).then((response) => {
      vm.item.agendaItemComments = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshAgendaItemDocuments() {
    const dfdRefresh = $q.defer();

    oversightDataService.getAgendaItemDocumentsByAgendaItem(vm.item.agendaItemId).then((response) => {
      vm.item.agendaItemDocuments = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshAgendaItemReports() {
    const dfdRefresh = $q.defer();

    oversightDataService.getAgendaItemReportsByAgendaItem(vm.item.agendaItemId).then((response) => {
      vm.item.agendaItemReports = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshAgendaItemFolders() {
    const dfdRefresh = $q.defer();

    oversightDataService.getAgendaItemFoldersByAgendaItem(vm.item.agendaItemId).then((response) => {
      vm.item.agendaItemFolders = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshAgendaItem() {
    const dfdRefresh = $q.defer();

    oversightDataService.getAgendaItem(vm.item.agendaItemId).then((response) => {
      vm.item = response.data;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }
}

EditAgendaItemDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'addAgendaItemNoteDialog',
  'attachAgendaItemDialog',
  'docDataService',
  'serviceIds',
  'loaderService',
  'oversightDataService',
  'ssDialogService'
];
